export const MODIFY_SHOWING_MINOR_TUTORIALS = 'MODIFY_SHOWING_MINOR_TUTORIALS';

export function modifyShowingMinorTutorials(showingMinorTutorials){
    return{
        type: MODIFY_SHOWING_MINOR_TUTORIALS,
        mainState: {
            showingMinorTutorials: showingMinorTutorials
        }
    }
}